var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@mui/material';
var SpaceDivider = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: ", "px;\n  margin-left: ", "px;\n"], ["\n  width: 100%;\n  margin-top: ", "px;\n  margin-left: ", "px;\n"])), function (props) { return (props.y || 1) * 8; }, function (props) { return (props.x || 1) * 8; });
export default SpaceDivider;
var templateObject_1;
